/**
 * Canonical site-effect defaults — single source (crm-bridge B2).
 *
 * Previously defined in core/state.js and DUPLICATED in ai/composer.js
 * (`DEFAULT_SITE_EFFECTS`) because the Worker cannot import the browser store's
 * module graph. Both now import from here; state.js re-exports for its existing
 * consumers. Pure data, worker-safe, no imports.
 */
export const SITE_EFFECT_DEFAULTS = Object.freeze({
  themeWipe: true,
  floatingLabels: true,
  goTopRing: true,
  // Momentum wheel scrolling (data/site-effects/smooth-scroll.js). Off by
  // default — it hijacks the wheel — and switched on per project by a template
  // whose source ran Lenis (see templateDeclaresSmoothScroll), or by hand.
  smoothScroll: false
});

/**
 * Did the template's source site run Lenis? The crawl keeps each page's
 * <html> class list in the page map (`sourceTemplateDocument.htmlClass`), and
 * Lenis stamps `lenis lenis-smooth` there. Pure and worker-safe: the loader
 * derives the project's `smoothScroll` default from it on template load.
 *
 * @param {{pages?: Array<{sourceTemplateDocument?: {htmlClass?: string}}>}|null} pageMap
 * @returns {boolean}
 */
export function templateDeclaresSmoothScroll(pageMap) {
  const pages = Array.isArray(pageMap?.pages) ? pageMap.pages : [];
  return pages.some((page) =>
    /(^|\s)lenis(\s|$)/.test(String(page?.sourceTemplateDocument?.htmlClass || ''))
  );
}
